import script from "./LessonEnding.vue?vue&type=script&setup=true&lang=js"
export * from "./LessonEnding.vue?vue&type=script&setup=true&lang=js"

import "./LessonEnding.vue?vue&type=style&index=0&id=5baf1196&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5baf1196"]])

export default __exports__